import React, { useContext } from "react";
import { caseTypesLookup } from "../config";
import { CasesContext } from "../CasesContext";
import "./CasesSubNav.scss";
import Dot from "../NotificationDot";

const CasesSubNav = (props) => {
  const { sortedCounts } = props;
  const { activeNav, setNavResetTab, setLocalActiveNav } =
    useContext(CasesContext);
  const handleKeyDown = (e, type) => {
    if (e.which === 32) {
      setNavResetTab(type);
      setLocalActiveNav(type);
      e.preventDefault();
    }
  };
  return (
    <div className="header-container">
      <div className="header-content">
        <div className="grid-row">
          <div className="tablet:grid-col-6">
            <h3 className="usa-flag-page-header">Cases</h3>
            <p className="headerInfo">
              View and manage cases throughout the application lifecycle.
            </p>
          </div>
          <div className="tablet:grid-col-6">
            <div className="notice">
              <strong>Important Note:</strong> The system will update your Cases
              Table approximately every 15 minutes with the latest information
              on your cases. Once the system updates and you refresh, navigate
              to, or return to this page during your session, you will see
              changes to your case information.
            </div>
          </div>
        </div>

        <div className="grid-row">
          <div className="navigation tablet:grid-col-12" id="cases_tabs">
            {sortedCounts.map((type, index) => {
              let typeLookupObj = caseTypesLookup[type.name];
              return (
                <a
                  role="tab"
                  aria-controls={"case_type_" + index}
                  tabindex={index + 1}
                  key={index}
                  onClick={() => {
                    setNavResetTab(typeLookupObj);
                    setLocalActiveNav(typeLookupObj);
                  }}
                  onKeyDown={(e) => handleKeyDown(e, typeLookupObj)}
                  className={
                    activeNav.machine_name === type.name
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  {type["data"]["hasActiveNotification"] && (
                    <Dot text={type.name} />
                  )}{" "}
                  <span style={{ marginLeft: 2 }}>{type.name}</span>
                  <span
                    className={
                      activeNav.machine_name === type.name
                        ? "badge active"
                        : "badge"
                    }
                  >
                    <div className="badge-number">{type["data"]["Total"]}</div>
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CasesSubNav;
